<template>
    <div>
        <p v-if="!calc.assumptions" class="text-body-1 text--typography1">
            This calculation has no assumptions.
        </p>
        <ul v-else>
            <li
                v-for="(a, i) in calc.assumptions"
                :key="i"
                class="mt-2 mb-2 text-wrap"
                v-html="makeAssumption(a)"
            ></li>
        </ul>
    </div>
</template>

<script>
export default {
    props: ['calc'],
    methods: {
        // Decode HTML entities like &lt;sub&gt; → <sub>
        decodeHTMLEntities(str) {
            const doc = new DOMParser().parseFromString(str, 'text/html')
            return doc.documentElement.textContent
        },

        // Insert <wbr/> ONLY in text nodes (never inside tags)
        insertWbrInTextNodes(text) {
            const container = document.createElement('div')
            container.textContent = text

            const walker = document.createTreeWalker(
                container,
                NodeFilter.SHOW_TEXT
            )
            const textNodes = []
            let node
            while ((node = walker.nextNode())) textNodes.push(node)

            textNodes.forEach((textNode) => {
                const value = textNode.nodeValue
                if (!value || !value.includes('/')) return

                // Build a fragment: text + (<wbr/> + '/'+ text) ...
                const parts = value.split('/')
                const frag = document.createDocumentFragment()

                parts.forEach((part, idx) => {
                    if (idx > 0) {
                        // Insert break opportunity + the slash character
                        frag.appendChild(document.createElement('wbr'))
                        frag.appendChild(document.createTextNode('/'))
                    }
                    if (part) frag.appendChild(document.createTextNode(part))
                })

                textNode.parentNode.replaceChild(frag, textNode)
            })

            return container.innerHTML
        },

        makeAssumption(assumption) {
            const decoded = this.decodeHTMLEntities(assumption)
            return this.insertWbrInTextNodes(decoded)
        },
    },
}
</script>
